import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { GREMLIN_PERSONAS, FLAVORS, FLAVOR_IMAGES } from "../lib/content";

export const GremlinGallery = () => (
  <section data-testid="gremlin-gallery-section" className="relative py-24 md:py-32 overflow-hidden">
    <div className="max-w-[1400px] mx-auto px-5 md:px-10 mb-12">
      <p className="font-mono text-xs uppercase tracking-[0.3em] text-ember mb-4">The Roster</p>
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4">
        <h2 className="font-display font-black uppercase tracking-tight text-cream text-5xl md:text-7xl leading-[0.9]">
          Meet the <span className="font-serif italic font-normal lowercase text-ember">gremlins</span>
        </h2>
        <p className="font-mono text-xs text-cream/65 max-w-xs">
          A character for every roast. Collect your favorites and swipe through the lineup.
        </p>
      </div>
    </div>

    <div className="flex gap-5 overflow-x-auto px-5 md:px-10 pb-6 snap-x snap-mandatory scrollbar-thin" data-testid="gremlin-gallery-strip" style={{ scrollbarWidth: "thin" }}>
      {GREMLIN_PERSONAS.map((p, i) => {
        const flavor = FLAVORS.find((f) => f.id === p.id);
        return (
          <motion.div
            key={p.id}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: (i % 4) * 0.07, ease: [0.16, 1, 0.3, 1] }}
            className="snap-start shrink-0 w-[260px] sm:w-[300px]"
          >
            <Link
              to={`/flavor/${p.id}`}
              data-testid={`gremlin-card-${p.id}`}
              className="group block border border-white/10 rounded-lg overflow-hidden bg-ash hover:border-ember/60 transition-colors h-full"
            >
              <div className="relative h-[280px] sm:h-[320px] overflow-hidden">
                <img src={FLAVOR_IMAGES[p.id]} alt={p.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-void/80 via-transparent to-transparent" />
                <span className="absolute top-3 left-3 font-mono text-[10px] uppercase tracking-widest text-void px-2.5 py-1 rounded-full" style={{ background: flavor?.accent }}>
                  #{String(i + 1).padStart(2, "0")}
                </span>
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="font-mono text-[10px] uppercase tracking-widest text-ember">{p.title}</p>
                  <h3 className="font-display font-black uppercase tracking-tight text-cream text-xl leading-tight mt-1">{flavor?.name}</h3>
                </div>
              </div>
              <div className="p-5">
                <p className="font-mono text-xs text-cream/75 leading-relaxed">{p.blurb}</p>
                <span className="inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-widest text-ember mt-4 group-hover:gap-3 transition-all">
                  Meet the bean <ArrowRight size={12} />
                </span>
              </div>
            </Link>
          </motion.div>
        );
      })}
    </div>
  </section>
);
